"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _analyticsConstants = require("./analyticsConstants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable */

class VWO extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "setVWO", () => {
      if (!window["_vwo_code"]) {
        window["_vwo_code"] = function () {
          var account_id = 310341,
            settings_tolerance = 2000,
            library_tolerance = 2500,
            use_existing_jquery = false,
            is_spa = 1,
            /* DO NOT EDIT BELOW THIS LINE */
            f = false,
            d = document;
          return {
            use_existing_jquery: function () {
              return use_existing_jquery;
            },
            library_tolerance: function () {
              return library_tolerance;
            },
            finish: function () {
              if (!f) {
                f = true;
                var a = d.getElementById("_vis_opt_path_hides");
                if (a) a.parentNode.removeChild(a);
              }
            },
            finished: function () {
              return f;
            },
            load: function (a) {
              var b = d.createElement("script");
              b.src = a;
              b.type = "text/javascript";
              //b.innerText;
              b.onerror = function () {
                window["_vwo_code"].finish();
              };
              d.getElementsByTagName("head")[0].appendChild(b);
            },
            init: function () {
              var settings_timer = setTimeout("_vwo_code.finish()", settings_tolerance);
              var a = d.createElement("style"),
                b = "body{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}",
                h = d.getElementsByTagName("head")[0];
              a.setAttribute("id", "_vis_opt_path_hides");
              a.setAttribute("type", "text/css");
              if (a.styleSheet) a.styleSheet.cssText = b;else a.appendChild(d.createTextNode(b));
              h.appendChild(a);
              this.load("//dev.visualwebsiteoptimizer.com/j.php?a=" + account_id + "&u=" + encodeURIComponent(d.URL) + "&f=" + +is_spa + "&r=" + Math.random());
              return settings_timer;
            }
          };
        }();
        window["_vwo_settings_timer"] = window["_vwo_code"].init();
      }
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.setVWO());
  }
}
exports.default = VWO;
VWO.propTypes = {
  /** VWO account Id. */
  vwoAccntId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
VWO.defaultProps = {
  vwoAccntId: _analyticsConstants.VWO_ACCOUNT_ID
};